var checkout = {

    stickyCart:function(target){

		$('.sticky-cart .toggle-sticky-cart').click(function(){
			$('.sticky-cart').toggleClass('show-sticky-cart');
			return false;
		});
		$('.sticky-cart .close-sticky-cart,.sticky-cart .sticky-cart-overlay').click(function(){
			$('.sticky-cart').removeClass('show-sticky-cart');
			return false;
		});
		
		if($('.sticky-cart-block .sticky-cart-content .cart-products').length > 0){
			var slider = $('.sticky-cart-block .sticky-cart-content .cart-products').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite:false,
				dots: false,
				arrows:false,
				nav:false, 
				responsive: [			
	                {
	                    breakpoint: 1200,
	                    settings: {
	                        slidesToShow: 3,
	                        slidesToScroll: 1,
	                        infinite: true,
	                        dots: false
	                    }
	                },
	                {
	                    breakpoint: 768,
	                    settings: {
	                        slidesToShow: 2,
	                        slidesToScroll: 1
	                    }
	                },
	                {
	                    breakpoint: 480,
	                    settings: {
	                        slidesToShow: 1,
	                        slidesToScroll: 1
	                    }
	                }
	            ]
			});
		}		
    }
};

function cardValidation () {
    var valid = true;
    var name = $('input[name="card_holder_name"]').val();
    var cardNumber = $('input[name="card_number"]').val();
    var month = $('select[name="exp_date_month"] option:selected').val();
    var year = $('select[name="exp_date_year"] option:selected').val();
    var cvc = $('input[name="cvc"]').val();

    if (name.trim() == "") {
        valid = false;
    }
    if (cardNumber.trim() == "") {
    	   valid = false;
    }

    if (month.trim() == "") {
    	    valid = false;
    }
    if (year.trim() == "") {
        valid = false;
    }
    if (cvc.trim() == "") {
        valid = false;
    }

    if(valid == false) {
       alert("All Fields are required");
    }

    return valid;
}

function stripeResponseHandler(status, response) {
    if (response.error) {
        alert(response.error.message);
    } else {
        $("#checkout_step_3_form").append("<input type='hidden' name='token' value='" + response['id'] + "' />");
        $("#checkout_step_3_form").submit();
    }
}

function stripePay(e) {
    e.preventDefault();

    var valid = cardValidation();

    if (valid == true) {
        var name 		= $('input[name="card_holder_name"]').val();
	    var cardNumber 	= $('input[name="card_number"]').val();
	    var month 		= $('select[name="exp_date_month"] option:selected').val();
	    var year 		= $('select[name="exp_date_year"] option:selected').val();
	    var cvc 		= $('input[name="cvc"]').val();

        Stripe.createToken({
            number: cardNumber,
            cvc: cvc,
            exp_month: month,
            exp_year: year
        }, stripeResponseHandler);
		
        return false;
    }
}

function initStripe(){
	$.getScript( "https://js.stripe.com/v2/", function( data, textStatus, jqxhr ) {
	  	Stripe.setPublishableKey("pk_test_1ercgyHikYZg7RaCmgZGOaLS00dDVzDSPt");
  		$('.check-out-btn button').on('click',stripePay);

	});
}

function initBraintree(authorization){
	$.getScript( "https://js.braintreegateway.com/web/3.43.0/js/client.js", function( data, textStatus, jqxhr ) {
  		$.getScript( "https://js.braintreegateway.com/web/3.43.0/js/hosted-fields.js", function( data, textStatus, jqxhr ) {
	  		runBraintree(authorization);
		});
	});
}

function runBraintree(authorization){
	var submit = document.querySelector('button[type="submit"]');
	
	braintree.client.create({
        authorization: 'sandbox_9qbgp8nk_bvxnbhrfs69htp8y'
	}, function (clientErr, clientInstance) {
        
		if (clientErr) {
          console.error(clientErr);
          return;
        }

        // This example shows Hosted Fields, but you can also use this
        // client instance to create additional components here, such as
        // PayPal or Data Collector.
        $('#card_number-container').empty();
        $('#cvc-container').empty();
        $('#exp_date_month_year-container').empty();

        braintree.hostedFields.create({
          client: clientInstance,
          styles: {
            'input': {
              	"color": "#121212",
				"border": "1px solid #121212",
				"height": "50px",
				"font-size": "16px",
				"padding":"15px 20px",
				"font-family": "MarkPro-Bold"

            },
            'input.invalid': {
              'color': 'red',
				"border": "1px solid #121212",
				"height": "50px",
				"font-size": "16px",
				"padding":"15px 20px",
				"font-family": "MarkPro-Bold"
            },
            'input.valid': {
              'color': 'green',
              	"border": "1px solid #121212",
				"height": "50px",
				"font-size": "16px",
				"padding":"15px 20px",
				"font-family": "MarkPro-Bold"
            }
          },
          fields: {
            number: {
	        selector: '#card_number-container',
              placeholder: '4111 1111 1111 1111'
            },
            cvv: {
	        	selector: '#cvc-container',
              placeholder: '123'
            },
            expirationDate: {
	        selector: '#exp_date_month_year-container',
              placeholder: '10/2019'
            }
          }
        }, function (hostedFieldsErr, hostedFieldsInstance) {
          
          if (hostedFieldsErr) {
            console.error(hostedFieldsErr);
            return;
          }

          submit.removeAttribute('disabled');
  			
  		$('.check-out-btn button').on('click',function(){
			hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
              if (tokenizeErr) {
                console.error(tokenizeErr);
                return;
              }
		        $("#checkout_step_3_form").append("<input type='hidden' name='token' value='" + payload.nonce + "' />");
				$("#checkout_step_3_form").submit();
            });
            return false;
  		});

          
        });
      });

}

function createHostedFields(clientInstance , form) {
	braintree.hostedFields.create({
    	client: clientInstance,
	    styles: {
	      'input': {
	        'font-size': '16px',
	        'font-family': 'courier, monospace',
	        'font-weight': 'lighter',
	        'color': '#ccc'
	      },
	      ':focus': {
	        'color': 'black'
	      },
	      '.valid': {
	        'color': '#8bdda8'
	      }
	    },
	    fields: {
	      number: {
	        selector: '#card_number',
	        placeholder: '4111 1111 1111 1111'
	      },
	      cvv: {
	        selector: '#cvc',
	        placeholder: '123'
	      },
	      expirationDate: {
	        selector: '#exp_date_month_year',
	        placeholder: 'MM/YYYY'
	      }
	    }
	  }, function (err, hostedFieldsInstance) {

		form.submit(function(event) {
		      event.preventDefault();

		      hostedFieldsInstance.tokenize({
		        	cardholderName: $('input[name="card_holder_name"]').val()
		      }, function(err, payload) {
		        if (err) {console.error(err);return;}
		        $("#checkout_step_3_form").append("<input type='hidden' name='token' value='" + payload.nonce + "' />");

		        // This is where you would submit payload.nonce to your server
		        // you can either send the form values with the payment
		        // method nonce via an ajax request to your server,
		        // or add the payment method nonce to a hidden inpiut
		        // on your form and submit the form programatically
		        $('#payment-method-nonce').val(payload.nonce);
		       	form.submit()
		      });
		  	});
   });
}

function UpdateCart($this) {
	$.ajax({
		type: "POST", 
		url: "/api/update-cart",
		data: { 
			product_id: $this.data('product'),  
			quantity: $this.val()
		},
		success:function(data){
			if(data.status === 'ok'){
				updateCartCounter(data.quantity);						
				$('.cart.partial,.partial.order-summary,.check-out.partial').each(function(){
					load_partial($(this));	
				});
			}else{
				actionResponseModal(data.message,'error','.actions-block .save');	
			}
		}
	});
}

function removeFromCart($this) {
	const productId = Number($this.data('id'));
	const quantity 	= Number($('.quantity-'+productId).val());
	const sku 		= $this.data('sku');
	const name 		= $this.data('name');
	const brand 	= $this.data('brand');
	const price 	= Number($this.data('price'));
	
	dataLayer.push({
		event: "remove_from_cart",
		currency: "USD",
		value: (price * quantity),
		items: [{
			item_id: sku,
			item_name: name,
			item_brand: brand,
			quantity: quantity,
			price: price
		}]
	});
	
	$.ajax({
		type: "POST",
		url: "/api/remove-from-cart",
		data: {
			product_id: productId
		},
		success: function(data) {
			if (data.status === 'ok') {
				updateCartCounter(data.quantity);                
                $('.cart.partial,.partial.order-summary,.check-out.partial').each(function() {
					load_partial($(this));
				});
                actionResponseModal(data.message,'success','.actions-block .save');
			}
			else {
				actionResponseModal(data.message,'error','.actions-block .save');	
			}
		}
	});
}

function CheckOutStep(data){
	if(data.location){
		if(data.location=='affirm'){
			AffirmCheckout(data);
		}else if(data.location=='paybright'){
			$('#paybright').html(data.response_template);	
			$('#pb_form').submit();
		}else{
			window.location = data.location;
			return false;
		}
		
	}else if(data.status === 'ok'){
		if(data.step==='confirm'){
			alert('redirect');
		}else{
			$('.check-out-steps li').removeClass('active');
			$('.check-out-steps li[data-step="'+data.next_step+'"]').addClass('active');
			$('.check-out-steps li[data-step="'+data.current_step+'"]').addClass('filled');
			$('.check-out .step').html(data.markup).promise().done(function(){
				 
				$('html,body').animate({ scrollTop: $(".check-out-content").offset().top - $("header").innerHeight() }, '500');
			    skinFormElements('.step');
				load_partial($('.partial.order-summary'));				
			});	
		}
		
	}else{
		actionResponseModal(data.message,'error','.actions-block .save');	
	}				
}

function CheckOutNavStep($this) {
	$step = $this.data('step');

	$.ajax({
		type: "POST", 
		url: "/api/checkout-nav", 
		data: { 
			step: $step
		},
		success:function(data) {
			if (data.status === 'ok') {
				$('.check-out-steps li.active').removeClass('active').addClass('filled');
				$('.check-out-steps li[data-step="'+$this.data('step')+'"]').addClass('active').removeClass('filled');

				$('.check-out .step').html(data.markup).promise().done(function(){
				$('html,body').animate({ scrollTop: 0 }, '500');
				    skinFormElements('.step');
				});
			}
			else {
				actionResponseModal(data.message,'error','.actions-block .save');	
			}
		}
	});
}

function AddToCart($this) {
	var quantity = $this.data('quantity') ? Number($this.data('quantity')) : 1;
	quantity = $('#input-quantity').length ? Number($('#input-quantity').val()) : quantity;
	
	const productId = Number($this.data('id'));
	const sku 		= $this.data('sku');
	const name 		= $this.data('name');
	const brand 	= $this.data('brand');
	const price 	= Number($this.data('price'));
	
	dataLayer.push({
		event: "add_to_cart",
		currency: "USD",
		value: (price * quantity),
		items: [{
			item_id: sku,
			item_name: name,
			item_brand: brand,
			quantity: quantity,
			price: price
		}]
	});
	
	$.ajax({
		type: "POST", 
		url: "/api/add-to-cart",
		dataType:'json',
		data: { 
			product_id: productId,
			quantity: quantity
		},
		success: function(data) {
			if (data.status === 'ok') {
				
				if ($this.closest('.upsales-options-modal').length) {
					$('.modal.upsales-options-modal').modal('hide');	
				}

				

				if (data.upsale_modal) {
					updateCartCounter(data.quantity);
					load_partial($('.cart.partial'));
					upsales(data.upsale_data);
				} else {
					setTimeout(function () { 
						window.location = '/'+LANGUAGE+'/cart';
					},100)
					
					//$('body').addClass('show-cart-sidebar');
				}
			}
			else {
				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	}); 
} 

function upsalesFilters($this){
	var $name = $this.attr('name');
	var $value = '["'+$this.val()+'"]';
	var $value = $this.val();
	$('.upsales-partial').data($name,$value);
	load_partial($('.upsales-partial'));	
}

     
 
function upsales_old($data){	
	var endpoint = '/partial/products.upsales-modal',
	del = '?route=catalogue/products&limit=4&with=shortcode&';
	for(var i in $data){
		endpoint+= del +  (i+"="+$data[i]); 
		$('.upsales-partial').data(i,$data[i] );	
		del = '&';
	} 
	$.ajax({ 
		url: endpoint,  
		success:function(data){							
			$('#ajax-content').append(data.markup);
			skinFormElements('.tires-modal'); 
			load_partial($('.upsales-partial'));
			$('.tires-modal').modal('show').on('hidden.bs.modal', function () {				
                $('.tires-modal').remove();
            }); 
		},
		error:function(d){
         	console.log(d);
        }
	}); 	
}

function AffirmCheckout(data){
	if(data.order){
		var _order = JSON.parse(data.order);

		affirm.checkout( _order );
		 affirm.checkout.open({
			onFail: function(a){},
			onSuccess: function(a){}
		});
	}

	return false;
}


function upsales($data){	
	var endpoint= '/partial/products.upsales-options-modal',
	del = '?route=catalogue/products&limit=4&';
	for(var i in $data){
		endpoint+= del +  (i+"="+$data[i]); 
		$('.upsales-partial').data(i,$data[i] );	
		del = '&';
	} 
	$.ajax({ 
		url: endpoint,  
		success:function(data){							
			$('#ajax-content').append(data.markup);
			skinFormElements('.upsales-options-modal'); 
			
			load_partial($('.upsales-partial'));
			load_partial($('.upsales-options-partial') , function(){
				upsales_options_update_totals($('.upsales-options-modal'));

			});

			$('.upsales-options-modal').modal('show').on('hidden.bs.modal', function () {				
                $('.upsales-options-modal').remove();
            }); 
		},
		error:function(d){
         	console.log(d);
        }
	}); 	
}

function upsales_options_update_totals(container){
	var $the_form = container.find('form[name="upsales_options"]');
	var $total = 0;
	container.find('form[name="upsales_options"] input').change(function(){
		$values = $the_form.serializeArray();		
		$('.totals-content .totals-products').empty();
		if (typeof $values.length !== "undefined" && $values.length>0) {
		    $('.totals-content').addClass('open');		    
		    $('.totals-content .totals-products').html();
		    $total = 0;
			for (var i = 0; i < $values.length; i++) {
			    var $id  = $values[i]['value'];
			    var $item = $('.upsales-options-modal .item[data-id="'+$id +'"]');

				$total =  $total + Number($item.data('price'));				
	            var mmm = $('.upsales-options-modal .item[data-id="'+$id +'"]').html();            
	            $('.totals-content .totals-products').append('<div class="item">'+mmm+'</div>');
	            $('.totals-content .totals-price span').html('$'+$total);             	            
			}
		}else{
			$('.totals-content').removeClass('open');
		}		
	});

} 
function  upsales_options_cart($this){	
	var $the_form = $this.closest('.upsales-options-partial').find('form[name="upsales_options"]');
	$values = $the_form.serializeArray();		
	var $data = {
		'items':[]

	};
	for (var i = 0; i < $values.length; i++) {		
	    var $id  = $values[i]['value'];
		$data.items[i] = { "id": $id, "quantity": 1 }		
	}		
	$.ajax({
		type: "POST", 
		url: "/api/add-to-cart-multy", 
		dataType:'json',
		data: $data,
		success:function(data){	
			if(data.status === 'ok'){
				if($this.closest('.upsales-options-modal').length){
					$('.modal.upsales-options-modal').modal('hide');	
				}
				updateCartCounter(data.quantity);
	            load_partial($('.cart.partial'));	                				
				$('body').addClass('show-cart-sidebar');

			}else{
				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	});	
}

function AddToCartPachage($this) {
	var $package = $this.closest('.item');

	$.ajax({
		type: "POST", 
		url: "/api/add-to-cart", 
		dataType:'json',
		data: { 
			product_id : $package.find('[name="product_id"]').val(),
			quantity : $package.find('input[name="quantity"]').val()
		},
		success: function (data) {
			if(data.status === 'ok'){
				updateCartCounter(data.quantity);				
                load_partial($('.cart.partial'));	                                
				actionResponseModal(data.message,'success','.actions-block .save');

			}else{
				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	}); 
} 

function updateCartCounter(quantity){
	if(quantity>99){
		$('header .cart .counter').html('99+');				
	}else{
		$('header .cart .counter').html(quantity);				
	}
	if(quantity > 0){
		$('header .cart').addClass('with-products');
	}else{
		$('header .cart').removeClass('with-products');
	}
}